import React, { memo, SVGProps } from 'react'

export const Filter = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.072 12C18.072 11.6026 17.7495 11.28 17.352 11.28H6.64801C6.25057 11.28 5.92801 11.6026 5.92801 12C5.92801 12.3974 6.25057 12.72 6.64801 12.72H17.352C17.7495 12.72 18.072 12.3974 18.072 12Z"
      fill="currentColor"
    />
    <path
      d="M4.12417 7.44H19.8759C20.2733 7.44 20.5959 7.11744 20.5959 6.72C20.5959 6.32256 20.2733 6 19.8759 6H4.12417C3.72673 6 3.40417 6.32256 3.40417 6.72C3.40417 7.11744 3.72673 7.44 4.12417 7.44Z"
      fill="currentColor"
    />
    <path
      d="M10.3555 16.56C9.95809 16.56 9.63553 16.8826 9.63553 17.28C9.63553 17.6774 9.95809 18 10.3555 18H13.7501C14.1475 18 14.4701 17.6774 14.4701 17.28C14.4701 16.8826 14.1475 16.56 13.7501 16.56H10.3555Z"
      fill="currentColor"
    />
  </svg>
))
